import { render } from "./internalRequests.vue?vue&type=template&id=ece7545a&scoped=true&ts=true"
import script from "./internalRequests.vue?vue&type=script&lang=ts"
export * from "./internalRequests.vue?vue&type=script&lang=ts"

import "./internalRequests.vue?vue&type=style&index=0&id=ece7545a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ece7545a"]])

export default __exports__